import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import Breadcrumb from "../../../../../Components/Utils/Breadcrumb";
import { BackButton } from "../../../../../Components/Utils/Buttons";

function SalesReportLayout() {
    const location = useLocation();
    let pathFile = location.pathname;
    const [value, setValue] = useState("")

    useEffect(() => {
        if (pathFile === "/reports/sales/customer-quote") {
            setValue("Customer Quote")
        }
    }, [location])

    return (
        <div className="w-full h-full px-2 sm:px-4 py-2 overflow-hidden">
            <div className="w-full flex flex-wrap sm:flex-nowrap justify-between items-center gap-2">
                <Breadcrumb items={[
                    {
                        name: "Report",
                        link: "/reports",
                    },
                    {
                        name: "Sales",
                    },
                    {
                        name: value,
                    }
                ]} />

                <BackButton />
            </div>

            <div className="w-full h-[calc(100vh-90px)] mt-1">
                <div className="w-full h-[calc(100vh-130px)] overflow-y-auto bg-white rounded-lg px-2 sm:px-3 pb-1">
                    <Outlet />
                </div>
            </div>
        </div>
    );
}

export default SalesReportLayout;
